import { render } from "./Cargando.vue?vue&type=template&id=38529b3b"
import script from "./Cargando.vue?vue&type=script&lang=js"
export * from "./Cargando.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__